import axios from "axios";
import React, { useEffect, useState, Component } from "react";
import "./Top_selling_card.css";
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import "./home_middle.css";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import explore from '../../Pages/Collections/Im/hcexplore.png';
import DatePicker from 'react-date-picker';
import ShareButton from "react-web-share-button";
import { RWebShare } from "react-web-share";
import Count from "./Count.js";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

const divStyle = {
    borderColor: 'white',
    border: "none",
    backgroundColor: 'transparent',
    borderRadius: '50px',
    color: 'white',
    width: '100%',
    textAlign: 'left',
    padding: '0',

};

function Top_selling_cards(props) {

    const [value, onChange] = useState(new Date());
    let history = useHistory();
    const responsive = {
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
        },
    };

    const [APIData, setAPIData] = useState([]);
    const [nftCount, setNftCount] = useState(8);
    const loadMoreNft = () => {
        setNftCount(nftCount + 8);
    };
    const [filteredData, setFilteredData] = useState([]);
    const handleSearch = (event) => {
        const selectValue = event.target.value;
        console.log(selectValue)
        let result = new Array();
        result = APIData.filter((data) => {
            if (parseInt(data.price) == selectValue) {
                return data;
            } else if (selectValue == 0) {
                return data;
            } else if (selectValue == data.auction) {
                return data;
            }
            if (data.film_name == selectValue) {
                return data;
            } else if (selectValue == "allmovie") {
                return data;
            }
            if (data.celebrity == selectValue) {
                return data;
            } else if (selectValue == "allactors") {
                return data;
            }
        });
        console.log(result);
        setFilteredData(result);
    }

    useEffect(() => {
        const sendGetRequest = async () => {
            try {
                const resp = await axios.get(`https://us-central1-diginoor-3755e.cloudfunctions.net/app/NFT/all`)
                    .then((resp) => {
                        // const nftData = response.data;
                        setAPIData(resp.data);
                        setFilteredData(resp.data);
                        console.log(resp.data);

                    });

            } catch (err) {
                // Handle Error Here
                console.error(err);
            }
        };
        sendGetRequest();

    }, []);

    setTimeout(function () {
        document.getElementById("skeleton_loader_nft").style.display = "none";
        document.getElementById("load_nft_data").style.display = "";
    }, 8000);


    return (
        <>
            <div className="top-sellers top-sellers-d">
                <div className="explore-head">
                    <h1 className="explore-top">EXPLORE<img className="hundred" src={explore} /></h1>
                    <div className="explore-top">
                    </div>
                    <div className="explore-top">
                        <select onChange={(event) => handleSearch(event)} name="actors">
                            <option selected value="allactors">All Actors</option>
                            <option value="Rajinikanth">Rajinikanth</option>
                            <option value="Vijay">Vijay</option>
                            <option value="Surya">Surya</option>
                            <option value="vivek">Vivek</option>
                        </select>
                    </div>
                    <div className="explore-top">
                        <select onChange={(event) => handleSearch(event)} name="actors">
                            <option selected value="allmovie">Movie</option>
                            <option value="Kabali">Kabali</option>
                            <option value="Sivaji">Sivaji</option>
                            <option value="Chandramukhi">Chandramukhi</option>
                        </select>
                    </div>
                    <div className="explore-top">
                        <select onChange={(event) => handleSearch(event)} name="price-range">
                            <option selected value="0">Price range</option>
                            <option value="Yes">Auction</option>
                            <option value="12.00">$12</option>
                            <option value="200.00">$200</option>
                        </select>
                    </div>
                </div>
                <div id="skeleton_loader_nft" style={{ display: '' }}>
                    {filteredData.map((data) => {

                        return (
                            <div key={data._id} className="top-carrdd">
                                <div style={data.celebrity == 'vivek' ? { position: 'relative', top: '0px' } : null} id="top-card" className={
                                    data.collection == "Rare" ? "rare-card top-card"
                                        : data.collection == "Legendary" ? "legendary-card top-card"
                                            : data.collection == "Ultimate" ? "ultimate-card top-card"
                                                : data.collection == "NonfungibleSPB" ? "nonfungible-card top-card"
                                                    : "top-card"}
                                >

                                    <img src={data.seller} className="lo" />
                                    <img src={data.film_image} className="lo" />
                                    <img src={data.seller} className="lo" />
                                    <div className="ts-dropdown">

                                        <button className="dropbtn"><i className="glyphicon glyphicon-option-horizontal"></i></button>
                                        <div className="dropdown-content" >
                                            <ul>
                                                <li><Link to="/contact">Report</Link></li>
                                                <li><a><RWebShare
                                                    data={{
                                                        text: "Check out this NFT",
                                                        url: `/nftdetail/${data._id}`,
                                                        title: data.nft_title,
                                                    }}
                                                    onClick={() => console.log("shared successfully!")}
                                                >
                                                    <button className="card-share-btn" style={divStyle}>Share</button>
                                                </RWebShare></a></li>
                                            </ul>

                                        </div>


                                    </div>
                                    <div>
                                        {/* <img className="" src={} alt="Logo" /> */}
                                        <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}><br></br>
                                            <Skeleton baseColor="#080824" width={240} className="top-im" highlightColor="#b1b2bc" /> </Link>
                                    </div>
                                    <div style={data.celebrity == 'vivek' ? null : { top: '0px' }} className="top-details">

                                        {/*  <a className="top-card-title" href={'/nftfinal/'+data.id}>{data.nft_title}</a>   */}

                                        {data.auction == 'Yes' && data.celebrity == 'vivek' ? <div className='nftdetail-timer'><Count /><p>left</p></div> : null}
                                        <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}>
                                        </Link>
                                        <p id="collection" className="top-card-title1">
                                            <Skeleton baseColor="#080824" width={50} height={10} highlightColor="#b1b2bc" /></p><br></br>
                                        <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`} style={{ paddingBottom: '50px' }}>
                                            <Skeleton baseColor="#080824" width={100} highlightColor="#b1b2bc" /></Link>


                                    </div>
                                    <div className="like">
                                        <FormControlLabel
                                            control={<Checkbox icon={<FavoriteBorder />}
                                                checkedIcon={<Favorite />}
                                                name="checkedH" />}
                                        />
                                    </div>
                                </div>

                            </div>
                        )
                    })}
                </div>
                <div id="load_nft_data">
                    {filteredData.map((data) => {

                        return (
                            <div key={data._id} className="top-carrdd">
                                <div id="top-card" className={
                                    data.collection == "Rare" ? "rare-card top-card"
                                        : data.collection == "Legendary" ? "legendary-card top-card"
                                            : data.collection == "Ultimate" ? "ultimate-card top-card"
                                                : data.collection == "NonfungibleSPB" ? "nonfungible-card top-card"
                                                    : "top-card"}
                                >

                                    <img src={data.seller} className="lo" />
                                    <img src={data.film_image} className="lo" />
                                    <img src={data.seller} className="lo" />
                                    <div className="ts-dropdown">

                                        <button className="dropbtn"><i className="glyphicon glyphicon-option-horizontal"></i></button>
                                        <div className="dropdown-content" >
                                            <ul>
                                                <li><Link to="/contact">Report</Link></li>
                                                <li><a><RWebShare
                                                    data={{
                                                        text: "Check out this NFT",
                                                        url: `/nftdetail/${data._id}`,
                                                        title: data.nft_title,
                                                    }}
                                                    onClick={() => console.log("shared successfully!")}
                                                >
                                                    <button className="card-share-btn" style={divStyle}>Share</button>
                                                </RWebShare></a></li>
                                            </ul>

                                        </div>


                                    </div>
                                    <div>
                                        {/* <img className="" src={} alt="Logo" /> */}
                                        <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}> <img src={data.nft_thumb} className="top-im" /></Link>
                                    </div>
                                    <div style={data.celebrity == 'vivek' ? null : { top: '0px' }} className="top-details">

                                        {/*  <a className="top-card-title" href={'/nftfinal/'+data.id}>{data.nft_title}</a>   */}

                                        {/* data.auction == 'Yes' && data.celebrity =='vivek' ? <div className='nftdetail-timer'><Count /><p>left</p></div>
               : null */ }
                                        <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}>
                                            <p style={{ marginTop: '-10px' }} className={
                                                data.collection == "NonfungibleSPB" ? "nonfungiblecard top-card-title" : "top-card-title"}> {data.nft_title}</p></Link>
                                        <p id="collection" className="top-card-title1">{data.collection}</p>
                                        <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}> <p className={
                                            data.collection == "NonfungibleSPB" ? "nonfungiblecard top-card-title-price" : "top-card-title-price"}>{data.celebrity == 'vivek' ? `${data.price} MAT` : `$${data.price}`}</p></Link>


                                    </div>
                                    <div className="like">
                                        <FormControlLabel
                                            control={<Checkbox icon={<FavoriteBorder />}
                                                checkedIcon={<Favorite />}
                                                name="checkedH" />}
                                        />
                                    </div>
                                </div>

                            </div>
                        )
                    })}
                </div>
            </div>


            <div className="top-sellers top-sellers-tb">
                <div className="explore-head explore-head-m">
                    <h1 className="explore-top">EXPLORE<img className="hundred" src={explore} /></h1>
                    <div className="explore-top">
                    </div>
                    <div className="explore-top">
                        <select onChange={(event) => handleSearch(event)} name="actors">
                            <option selected value="all">All Actors</option>
                            <option value="Rajinikanth">Rajinikanth</option>
                            <option value="Vijay">Vijay</option>
                            <option value="Surya">Surya</option>
                            <option value="vivek">Vivek</option>
                        </select>
                    </div>
                    <div className="explore-top">
                        <select onChange={(event) => handleSearch(event)} name="actors">
                            <option selected value="allmovie">Movie</option>
                            <option value="Kabali">Kabali</option>
                            <option value="Sivaji">Sivaji</option>
                            <option value="Chandramukhi">Chandramukhi</option>
                        </select>
                    </div>
                    <div className="explore-top">
                        <select onChange={(event) => handleSearch(event)} name="price-range">
                            <option selected value="allprice">Price range</option>
                            <option value="Yes">Auction</option>
                            <option value="12.00">$12</option>
                            <option value="200.00">$200</option>

                        </select>
                    </div>
                </div>

                {/* <h1 className="thead">TOP SELLERS</h1> */}
                <Carousel
                    responsive={responsive}
                    autoPlay={true}
                    autoPlaySpeed={5000}
                    infinite={true}
                >
                    {filteredData.map((data) => {
                        return (
                            <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}>
                                <div key={data._id} className="top-carrdd">
                                    {/* card1...................................... */}
                                    <div id="top-card" className={
                                        data.collection == "Rare" ? "rare-card top-card"
                                            : data.collection == "Legendary" ? "legendary-card top-card"
                                                : data.collection == "Ultimate" ? "ultimate-card top-card"
                                                    : data.collection == "NonfungibleSPB" ? "nonfungible-card top-card"
                                                        : "top-card"}
                                    >

                                        <img src={data.seller} className="lo" />
                                        <img src={data.film_image} className="lo" />
                                        <img src={data.seller} className="lo" />
                                        <div className="ts-dropdown">

                                            <button className="dropbtn"><i className="glyphicon glyphicon-option-horizontal"></i></button>
                                            <div className="dropdown-content" >
                                                <p><Link to="/contact">Report</Link></p>
                                                <p><ShareButton buttonStyle={divStyle} /></p>
                                            </div>

                                        </div>
                                        <div>
                                            {/* <img className="" src={} alt="Logo" /> */}
                                            <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}> <img src={data.nft_thumb} className="top-im" /></Link>
                                        </div>
                                        <div className="top-details">

                                            {/*  <a className="top-card-title" href={'/nftfinal/'+data.id}>{data.nft_title}</a>   */}
                                            {/* data.auction == 'Yes' && data.celebrity =='vivek' ?
               <div className='nftdetail-timer'><Count /><p>left</p></div> : null */}
                                            <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}>
                                                <p style={{ marginTop: '-10px' }} className={
                                                    data.collection == "NonfungibleSPB" ? "nonfungiblecard top-card-title" : "top-card-title"}> {data.nft_title}</p></Link>
                                            <p id="collection" className="top-card-title1">{data.collection}</p>
                                            <Link to={data.collection == "NonfungibleSPB" ? '/nonfungiblespb' : `/nftdetail/${data.id}`}> <p className={
                                                data.collection == "NonfungibleSPB" ? "nonfungiblecard top-card-title-price" : "top-card-title-price"}>{data.celebrity == 'vivek' ? `${data.price} MAT` : `$${data.price}`}</p></Link>


                                        </div>
                                        <div className="like">
                                            <FormControlLabel
                                                control={<Checkbox icon={<FavoriteBorder />}
                                                    checkedIcon={<Favorite />}
                                                    name="checkedH" />}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </Link>
                        )
                    })}
                </Carousel>
            </div>
        </>
    )

}

export default Top_selling_cards